<template>
    <div class="md-layout text-center">
        <div class="md-layout-item md-size-50 md-small-size-100">
            <h1 style="color:#fff"
            >404 ! Not Found</h1>

            <b-button variant="success"  @click="$router.push('/explore')">
                <i class="fa fa-home"/>Return home
            </b-button>
        </div>
    </div>
</template>
<script>
  export default {
    components: {
    },
    data ()
    {
      return {
      }
    }
  }
</script>
<style>


</style>
